import React from 'react';
import {renderRichText} from "gatsby-source-contentful/rich-text";
import {BLOCKS} from "@contentful/rich-text-types";

function TextWithImageSection(props) {
    let type = props.content.imageLocation === 'right' ? 'left-to-right' : 'right-to-left';

    return (
        <section key={props.key} className={`text-with-image-section ${type || 'left-to-right'}`}>
            <div className="container">
                <div className="row align-items-center">
                    <div className={`col-left col-lg-6 ${type === 'right-to-left' ? 'order-lg-2 order-2' : 'order-lg-1 order-2'}`}>
                        <h2>{props.content.title}</h2>
                        {renderRichText(props.content.body)}
                        { (props.content.ctaUrl && props.content.ctaText) &&
                            <a href={props.content.ctaUrl}
                                target="_blank"
                                rel="noreferrer"
                                className="btn mt-4">
                                {props.content.ctaText}
                            </a>
                        }
                    </div>
                    <div className={`col-right col-lg-6 ${type === 'right-to-left' ? 'order-lg-1 order-1 text-lg-left pe-5' : 'order-lg-2 order-1 text-lg-right'}`}>
                        <div className={'image'}>
                            <img src={props.content.image.url} alt={props.content.image.title}/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default TextWithImageSection;
